// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2mEFW","infoBtn":"quickbooks_infoBtn__1YNVC","formBox":"quickbooks_formBox__1pLML","formFooter":"quickbooks_formFooter__2QZw9"};